var map = {
	"./age_rating_0.svg": 89565,
	"./age_rating_12.svg": 98758,
	"./age_rating_16.svg": 86266,
	"./age_rating_18.svg": 75295,
	"./age_rating_7.svg": 55634,
	"./app_store.svg": 62546,
	"./app_store_full.svg": 57714,
	"./appstore.svg": 84347,
	"./blik.svg": 90297,
	"./calendar.svg": 85033,
	"./cards.svg": 65296,
	"./checkIcon.svg": 66078,
	"./close.svg": 35837,
	"./close_thin.svg": 4257,
	"./device_pc.svg": 27251,
	"./device_phone.svg": 8780,
	"./device_tablet.svg": 70208,
	"./device_tv.svg": 91178,
	"./exit_fullscreen.svg": 70333,
	"./facebook.svg": 43479,
	"./fullscreen-vod.svg": 99500,
	"./fullscreen.svg": 25276,
	"./google_play_full.svg": 5941,
	"./googleplay.svg": 3020,
	"./gpay.svg": 98388,
	"./ic_adult.svg": 16514,
	"./ic_arrow_down.svg": 21108,
	"./ic_arrow_l.svg": 88012,
	"./ic_arrow_r.svg": 72042,
	"./ic_auth_apple.svg": 9605,
	"./ic_auth_facebook.svg": 42675,
	"./ic_auth_google.svg": 21354,
	"./ic_basket.svg": 89696,
	"./ic_bell.svg": 26789,
	"./ic_blik.svg": 47356,
	"./ic_bluemedia.svg": 18502,
	"./ic_button_favourite_add.svg": 48014,
	"./ic_button_favourite_remove.svg": 37065,
	"./ic_button_play.svg": 2351,
	"./ic_button_preview.svg": 89739,
	"./ic_button_price.svg": 1376,
	"./ic_clock.svg": 17492,
	"./ic_close.svg": 21570,
	"./ic_close_thin.svg": 27636,
	"./ic_decoder.svg": 69846,
	"./ic_devices_available.svg": 64903,
	"./ic_devices_available_mobile.svg": 76712,
	"./ic_favorite.svg": 1234,
	"./ic_favorite_border.svg": 42087,
	"./ic_favorite_full.svg": 32786,
	"./ic_favourite.svg": 64243,
	"./ic_file.svg": 91932,
	"./ic_gears.svg": 91438,
	"./ic_grid.svg": 57886,
	"./ic_info.svg": 58814,
	"./ic_invoice_payment_completed.svg": 42094,
	"./ic_list.svg": 37458,
	"./ic_list_check.svg": 87447,
	"./ic_list_dot.svg": 50178,
	"./ic_live.svg": 41216,
	"./ic_lock.svg": 97295,
	"./ic_lock_second.svg": 64294,
	"./ic_mastercard.svg": 61154,
	"./ic_more_info.svg": 20808,
	"./ic_password_hide.svg": 1592,
	"./ic_password_show.svg": 33323,
	"./ic_phone.svg": 39094,
	"./ic_play.svg": 516,
	"./ic_profile.svg": 2821,
	"./ic_rec.svg": 8524,
	"./ic_reminder.svg": 55540,
	"./ic_rewind.svg": 11659,
	"./ic_screen.svg": 72034,
	"./ic_search.svg": 52462,
	"./ic_share.svg": 77611,
	"./ic_show_all.svg": 39937,
	"./ic_tick.svg": 92653,
	"./ic_transaction_completed.svg": 93924,
	"./ic_transaction_failed.svg": 3378,
	"./ic_transaction_pending.svg": 47350,
	"./ic_trash.svg": 9184,
	"./ic_tv.svg": 87860,
	"./ic_user_logout.svg": 91024,
	"./ic_visa.svg": 44037,
	"./laptop.svg": 24667,
	"./logo.svg": 26962,
	"./logo_maxelectro.svg": 86735,
	"./logo_small.svg": 12486,
	"./logo_vectra.svg": 70024,
	"./mastercard.svg": 40251,
	"./minimalize.svg": 74482,
	"./mobile.svg": 78257,
	"./modal_ic_close.svg": 69552,
	"./new_ic_bell.svg": 54018,
	"./nexgentv.svg": 70676,
	"./nexgentv_go.svg": 86853,
	"./next.svg": 72396,
	"./pause.svg": 51947,
	"./phone.svg": 16345,
	"./placeholder.svg": 15850,
	"./placeholder_horizontal.svg": 32329,
	"./play.svg": 10757,
	"./previous.svg": 40612,
	"./promotion.svg": 80426,
	"./seek_15_next.svg": 80720,
	"./seek_15_prev.svg": 18104,
	"./settings.svg": 20716,
	"./star_empty.svg": 49425,
	"./star_full.svg": 13557,
	"./test/search_icon.svg": 99930,
	"./test/share_icon.svg": 5549,
	"./tick.svg": 16920,
	"./triangle-border.svg": 84190,
	"./triangle.svg": 11907,
	"./tv.svg": 85369,
	"./underline.svg": 93081,
	"./vectra_logo.svg": 14736,
	"./vectra_new_logo.svg": 21333,
	"./visa.svg": 99468,
	"./vod_heart.svg": 46635,
	"./vod_heart_full.svg": 90158,
	"./vod_play.svg": 68099,
	"./volume.svg": 21033,
	"./volume_off.svg": 1627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;